import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AvisoLegal from "@/pages/legal/AvisoLegal";
import PoliticaPrivacidad from "@/pages/legal/PoliticaPrivacidad";
import PoliticaCookies from "@/pages/legal/PoliticaCookies";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/aviso-legal" element={<AvisoLegal />} />
                    <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
                    <Route path="/politica-de-cookies" element={<PoliticaCookies />} />
                </Routes>
                <CookieBanner />
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0E1626",
                        border: "1px solid rgba(244,201,181,0.35)",
                        color: "#FBF6F0",
                        borderRadius: 6,
                    },
                }}
            />
        </div>
    );
}

export default App;
